import React from 'react';
import styles from './ComebackArrow.module.scss';
import { useNavigate } from 'react-router-dom';

const ComebackArrow = ({path, state}) => {
  let navigate = useNavigate();

  const handleClick = () => {
    navigate(path, state ? { state: state } : {});
  };

  return (
    <div className={`d-flex align-items-center ${styles.comebackArrow} my-2`}>
      <div role='button' className={`d-flex justify-content-center align-items-center ${styles.arrowCircle}`} onClick={handleClick}>
        <i className={`bi bi-arrow-left ${styles.arrowIcon}`}></i>
      </div>
      <span className={styles.backText}>Indietro</span>
    </div>
  );
};

export default ComebackArrow;
